import React, { useEffect, useState, useRef } from 'react';
import LinksHome from './Links/Links-home'

const HomeNavigationTile = (props) => {

  const [componentdata, setComponentdata] = useState([])
  const [cheight, setCheight] = useState(0)
  let dheight = 0
  
  useEffect(() => {
    if (props.fields) {
      setComponentdata(props.fields.items)
    }
  }, [])  

  const getHeight = (el) => {
    if (!el) return; 
    let gheight = el.getBoundingClientRect().height
    //console.log(gheight)
    if(gheight > cheight)
      setCheight(gheight);    
  }

  useEffect(()=>{
    //console.log('cheight: ',cheight)
  },[cheight])

  return (
    <div className="utilitytools">
      {
        componentdata.map((category, index) => {
          return <section key={index}>
            <div className="category-heading">
              <h3 style={{ minHeight: cheight }} ref = { el => getHeight(el) }>{category.fields.title.value}</h3>
            </div>
            <LinksHome linkdetails={category.fields.links} />
          </section>
        })
      }
    </div>
  )
};

export default HomeNavigationTile;